__turbopack_context__.v({
  "acheivername": "pubad-optional-module__n9ROSa__acheivername",
  "acheivername1": "pubad-optional-module__n9ROSa__acheivername1",
  "acheiverrank": "pubad-optional-module__n9ROSa__acheiverrank",
  "acheiverrank1": "pubad-optional-module__n9ROSa__acheiverrank1",
  "acheiverrank2": "pubad-optional-module__n9ROSa__acheiverrank2",
  "acheiverrank3": "pubad-optional-module__n9ROSa__acheiverrank3",
  "acheiverrank4": "pubad-optional-module__n9ROSa__acheiverrank4",
  "acheivertitle": "pubad-optional-module__n9ROSa__acheivertitle",
  "ansheet": "pubad-optional-module__n9ROSa__ansheet",
  "bgboxbg": "pubad-optional-module__n9ROSa__bgboxbg",
  "captcha": "pubad-optional-module__n9ROSa__captcha",
  "checkboxcontent": "pubad-optional-module__n9ROSa__checkboxcontent",
  "classesborder": "pubad-optional-module__n9ROSa__classesborder",
  "contactbox": "pubad-optional-module__n9ROSa__contactbox",
  "contactboxheight": "pubad-optional-module__n9ROSa__contactboxheight",
  "contactsubcontent": "pubad-optional-module__n9ROSa__contactsubcontent",
  "gshad": "pubad-optional-module__n9ROSa__gshad",
  "img": "pubad-optional-module__n9ROSa__img",
  "imgboxbelow": "pubad-optional-module__n9ROSa__imgboxbelow",
  "invalidCheck2": "pubad-optional-module__n9ROSa__invalidCheck2",
  "mainshead": "pubad-optional-module__n9ROSa__mainshead",
  "mbtableheading": "pubad-optional-module__n9ROSa__mbtableheading",
  "medalicon": "pubad-optional-module__n9ROSa__medalicon",
  "mobhead": "pubad-optional-module__n9ROSa__mobhead",
  "mobilemaillinks": "pubad-optional-module__n9ROSa__mobilemaillinks",
  "more": "pubad-optional-module__n9ROSa__more",
  "normalbutton": "pubad-optional-module__n9ROSa__normalbutton",
  "normalbutton2": "pubad-optional-module__n9ROSa__normalbutton2",
  "pagemaintitle": "pubad-optional-module__n9ROSa__pagemaintitle",
  "paybill": "pubad-optional-module__n9ROSa__paybill",
  "paybills": "pubad-optional-module__n9ROSa__paybills",
  "redunderline": "pubad-optional-module__n9ROSa__redunderline",
  "sectiontitle": "pubad-optional-module__n9ROSa__sectiontitle",
  "sectiontitle1": "pubad-optional-module__n9ROSa__sectiontitle1",
  "sectiontitle2": "pubad-optional-module__n9ROSa__sectiontitle2",
  "subhead": "pubad-optional-module__n9ROSa__subhead",
  "tableheading": "pubad-optional-module__n9ROSa__tableheading",
  "tablepara": "pubad-optional-module__n9ROSa__tablepara",
  "tablepara1": "pubad-optional-module__n9ROSa__tablepara1",
  "tablescroll": "pubad-optional-module__n9ROSa__tablescroll",
  "toppersupsc": "pubad-optional-module__n9ROSa__toppersupsc",
  "viewbutton": "pubad-optional-module__n9ROSa__viewbutton",
});
